export const ContactUs = () => {
  return (
    <div id="contact-us" className="text-center">
      <div className="container">
        <div className="contact-us-main">
          <div className="contact-us-1" />
          <div className="contact-us-2" />
          <div className="contact-us-3" />
          <div className="contact-us-4" />
          <div className="section-title">
            <h2>Ready to Transform Your <span>Business?</span></h2>
            <p>Let's discuss how our IT solutions can help you achieve your goals.</p>
          </div>
        </div>

        {/* <div className="row">
          <a href="#services" className="btn btn-custom btn-lg page-scroll">
            Contact Us
          </a>
        </div> */}
      </div>
    </div>
  );
};
